import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildRevenueDiversificationChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelRevenueDiversification = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Revenue Diversification";
  const lines = stripTitleLines(cleanLines(markdown));
  const { table, before, after } = extractTableBlock(lines);
  const chart = buildRevenueDiversificationChart(table);
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Concentration Risk"
      sections={[
        {
          title: "Concentration Metrics",
          chart,
          chartTitle: "Diversification Mix",
          chartSubtitle:
            "A doughnut is perfect here because this report is really about who owns too much of the pie.",
          table,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "What Does This Mean?",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelRevenueDiversification;
